module.exports = __webpack_public_path__ + "img/40_38_069_180.b2cfad1f.jpg";